import { render, staticRenderFns } from "./StandardPlus.vue?vue&type=template&id=73109cc0"
import script from "./StandardPlus.vue?vue&type=script&lang=js"
export * from "./StandardPlus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports